import api from "./api";

export const getUserFavorites = async (userId) => {
    try {
        const response = await api.get(`/favorites?populate[establishment][populate]=*&filters[$and][0][user][$eq]=${userId}`);
        
        // Filter out favorites where establishment ID doesn't exist
        const filteredFavorites = response.data.data.filter(favorite => {
            const hasEstablishment = favorite.establishment?.id;
            
            if (!hasEstablishment) {
                // Delete the favorite if establishment doesn't exist
                deleteFavorite(favorite.documentId);
                return false;
            }
            return true;
        });
        
        return filteredFavorites;
    } catch(e) {
        console.error(e);
        return [];
    }
};

export const checkIsFavorite = async (userId, establishmentId) => {
    try {
        const response = await api.get(`/favorites?filters[$and][0][user][$eq]=${userId}&filters[$and][1][establishment][$eq]=${establishmentId}`);
        // console.log(response);

        // Validate response structure
        if (!response?.data?.data) {
            console.warn('checkIsFavorite: Unexpected response structure');
            return {
                id: null,
                isFavorite: false
            };
        }

        // Safely access data
        const favorites = Array.isArray(response.data.data) ? response.data.data : [];
        const firstFavorite = favorites[0] || {};

        return {
            id: firstFavorite.documentId || null,
            isFavorite: favorites.length > 0
        };
        const data = {
            id: response.data?.data[0]?.documentId ? response.data.data[0].documentId : null,
            isFavorite: response.data.data.length > 0
        }
        // console.log(data);
        return data;
    } catch(e) {
        console.error(e);
        return false;
    }
};

export const addToFavorites = async (data) => {
    try{
        const response = await api.post(`/favorites`, data);
        // console.log(response);
        const returnData = {
            id: response.data.data.documentId ? response.data.data.documentId : null,
            success: response.data.data.documentId ? true : false
        }
        return returnData;
    }catch(e){
        console.error(e);
        return false;
    }
};

export const deleteFavorite = async (favoriteId) => {
    try{
        await api.delete(`/favorites/${favoriteId}`);
        // console.log(response);
        return true;
    }catch(e){
        console.error(e);
        return false;
    }
};